import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    const isLoginEndpoint = original?.url?.includes("/api/auth/login");

    if (err.response?.status === 401 && !original._retry && !isLoginEndpoint) {
      original._retry = true;
      const refresh = localStorage.getItem("refresh_token");
      if (refresh) {
        try {
          const { data } = await axios.post(`${BASE}/api/auth/refresh`, { refresh_token: refresh });
          localStorage.setItem("access_token", data.access_token);
          original.headers.Authorization = `Bearer ${data.access_token}`;
          return api(original);
        } catch {
          // refresh also failed — fall through to session-expired redirect
        }
      }
      // No valid session: clear tokens, flag session expiry, redirect to login
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      sessionStorage.setItem("session_expired", "1");
      window.location.href = "/login";
      return new Promise(() => {}); // prevent error from propagating to callers
    }

    return Promise.reject(err);
  }
);

export const getMediaUrl = (path) => {
  if (!path) return null;
  // If already an absolute URL (e.g. direct GCS/CDN public URL), pass it through unchanged.
  if (/^https?:\/\//i.test(path)) return path;
  // Otherwise treat it as a backend-relative path (legacy "/api/media/..." proxy URLs).
  return `${BASE}${path}`;
};
